import React from 'react';
import { BellIcon, CalendarIcon, ChevronDownIcon, ConciergeBellIcon, MenuIcon } from 'lucide-react';
import { properties } from '../data/dashboardData';
type DashboardHeaderProps = {
  property: string;
  onPropertyChange: (property: string) => void;
};
export function DashboardHeader({
  property,
  onPropertyChange
}: DashboardHeaderProps) {
  const selected = properties.find(item => item.id === property) ?? properties[0];
  return <header className="border-b border-[#d8d2c6] bg-[#fbf8f1]" data-id="element-20">
      <div className="flex h-16 items-center justify-between px-4 sm:px-6 lg:hidden" data-id="element-21">
        <button type="button" aria-label="Open navigation" className="rounded p-2 text-[#0b2032] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#aa8649]" data-id="element-22">
          <MenuIcon size={21} data-id="element-23" />
        </button>
        <div className="flex items-center gap-2 font-serif text-lg text-[#0b2032]" data-id="element-24">
          <ConciergeBellIcon size={19} className="text-[#aa8649]" data-id="element-25" /> Aurelian
        </div>
        <button type="button" aria-label="View alerts" className="relative rounded p-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#aa8649]" data-id="element-26">
          <BellIcon size={19} data-id="element-27" />
          <span className="absolute right-1 top-1 h-2 w-2 rounded-full bg-[#a6543d]" data-id="element-28" />
        </button>
      </div>
      <div className="flex flex-col justify-between gap-4 px-4 py-5 sm:px-6 md:flex-row md:items-center xl:px-8" data-id="element-29">
        <div data-id="element-30">
          <p className="mb-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-[#9a7b45]" data-id="element-31">
            Daily revenue briefing
          </p>
          <h1 className="font-serif text-2xl text-[#0b2032] sm:text-[28px]" data-id="element-32">
            Good morning, Alexandra
          </h1>
          <p className="mt-1 text-xs text-[#65717a]" data-id="element-33">
            Thursday, 9 July 2026 · Updated at 08:42 CEST
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-2" data-id="element-34">
          <label className="relative" data-id="element-35">
            <span className="sr-only" data-id="element-36">Select property</span>
            <select value={property} onChange={event => onPropertyChange(event.target.value)} className="h-11 min-w-[220px] appearance-none border border-[#cfc7b8] bg-white py-2 pl-3 pr-9 text-sm font-medium text-[#0b2032] shadow-sm focus:outline-none focus:ring-2 focus:ring-[#aa8649]" data-id="element-37">
              {properties.map(item => <option value={item.id} key={item.id} data-id="element-38">
                  {item.name}
                </option>)}
            </select>
            <ChevronDownIcon aria-hidden="true" size={15} className="pointer-events-none absolute right-3 top-3.5 text-[#7a756b]" data-id="element-39" />
          </label>
          <div className="flex h-11 items-center gap-2 border border-[#cfc7b8] bg-white px-3 text-xs text-[#4e5b64] shadow-sm" data-id="element-40">
            <CalendarIcon size={15} className="text-[#9a7b45]" data-id="element-41" />
            <span data-id="element-42">9 Jul — 8 Aug</span>
          </div>
          <button type="button" aria-label="View alerts" className="relative hidden h-11 w-11 place-items-center border border-[#cfc7b8] bg-white text-[#0b2032] shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#aa8649] lg:grid" data-id="element-43">
            <BellIcon size={17} data-id="element-44" />
            <span className="absolute right-2 top-2 h-2 w-2 rounded-full bg-[#a6543d]" data-id="element-45" />
          </button>
        </div>
      </div>
      <div className="border-t border-[#e2ddd3] px-4 py-2 text-[11px] text-[#77766f] sm:px-6 xl:px-8" data-id="element-46">
        <span className="font-semibold text-[#0b2032]" data-id="element-47">{selected.name}</span>
        <span className="mx-2 text-[#b2aa9d]" data-id="element-48">/</span>
        {selected.detail}
      </div>
    </header>;
}